module.exports = __webpack_public_path__ + "img/manage-stake.e4b80ced.svg";